export const iconFontAwesomeLogisticsPallet = (
	<i className="fa-solid fa-pallet"></i>
);
